import { apiCall } from '../../context/api';

export const fetchEventsFeed = async (token, base_url) => {
  return apiCall(base_url, token, 'GET', '/core/users/feeds/events');
};

export const fetchInvoiceQueue = async(token, base_url) => {
  return apiCall(base_url, token, 'GET', '/core/users/feeds/invoices-queue');
};